<template>
    <h4 v-if="title" class="text-black md:text-[1.2rem] sm:text-[1.2rem] font-medium mb-[0.8rem]">{{title}}</h4>
    <ul class="flex flex-col ml-8 gap-3 pl-8 mb-[1.2rem]">
      <li class="text-black md:text-[1.2rem] sm:text-[1.2rem] font-medium list-disc" v-for="(item, index) in visibleList" :key="index">{{ item }}</li>
    </ul>
    <a v-if="showMoreButton" href="#" class="text-black md:text-[1.2rem] sm:text-[1.2rem] font-medium underline" @click.prevent="showAll">{{$t("Show more")}}</a>
</template>

<script>
export default {
  name: 'TextList',
  props: {
    list: {
      type: Array,
      required: true
    },
    title:{
        type: String,
        required: false
    },
    showMoreContentBtn: {
      type: Boolean,
      default: true,
    },
    maxItems: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      isExpanded: false,
    };
  },
  computed: {
    normalizedList() {
      return Array.isArray(this.list) ? this.list : [];
    },
    shouldCollapse() {
      return this.showMoreContentBtn && this.maxItems > 0 && this.normalizedList.length > this.maxItems;
    },
    visibleList() {
      if (!this.shouldCollapse || this.isExpanded) {
        return this.normalizedList;
      }
      return this.normalizedList.slice(0, this.maxItems);
    },
    showMoreButton() {
      return this.shouldCollapse && !this.isExpanded;
    },
  },
  watch: {
    list() {
      this.isExpanded = false;
    },
  },
  methods: {
    showAll() {
      this.isExpanded = true;
    },
  }
}
</script>

<style scoped>
</style>
